import { getTypeValue } from "../../../../../helpers/common/searchers/index.js";
import { formatDate } from "../../../../../helpers/date.js";
import { parseFilters } from "../../../../../helpers/url.js";
const getAccommodationParam = (accommodation)=>{
    if (!accommodation?.rooms) return [
        ''
    ];
    return accommodation.rooms.map(({ adults , childrenAges  })=>{
        const adultsValues = [
            ...Array(adults)
        ].fill('30A').reduce((acc, val)=>acc + val);
        const childrenParam = childrenAges?.length ? childrenAges.map((c)=>`${c}${'C'}`).join('') : '';
        return `${adultsValues}${childrenParam}`;
    });
};
/* Build url */ export async function buildUrl(fieldValues, baseUrl, url = '/packagesasyncstepssp/AvailabilityMaterial/', params) {
    const { accommodation , dates , destination , origin , discounts , classes  } = fieldValues;
    let finalUrl = url;
    if (!finalUrl.startsWith('http')) finalUrl = `${baseUrl}${url}`;
    const filters = {
        productType: 'FlightHotel',
        LineOfBusiness: 'Packages',
        originAirportCode: origin?.value,
        hashRooms: getAccommodationParam(accommodation).join('%2C'),
        destinationType: getTypeValue(destination).type,
        destinationCode: getTypeValue(destination).value,
        departureDateStr: dates?.[0] ? await formatDate(dates?.[0], 'yyyy-LL-dd') : '',
        returnDateStr: dates?.[1] ? await formatDate(dates?.[1], 'yyyy-LL-dd') : '',
        FamilyDiscount: discounts?.value || 0,
        CabinClass: classes?.value ?? '',
        ...params
    };
    return `${finalUrl}?${parseFilters(filters)}`;
}

//# sourceMappingURL=url.js.map